import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { FormContainerBoleto } from '@/features/cobranca-boleto/page/forms/FormContainerBoleto';
import { StringToIdpkSchema } from '@/std/schema';

const RouteCobrancaBoletoSchema = z.discriminatedUnion('action', [
    z.object({
        action: z.literal('cadastrar'),
        idpk: z.undefined().optional(),
    }),
    z.object({
        action: z.enum(['editar', 'visualizar']),
        idpk: StringToIdpkSchema,
    }),
]);

export type RouteCobrancaBoletoParams = z.infer<typeof RouteCobrancaBoletoSchema>;

export const Route = createFileRoute('/a/cobranca-boleto/$action/{-$idpk}')({
    component: Component,
    params: {
        parse: (params) => {
            const result = RouteCobrancaBoletoSchema.safeParse(params);

            return result.success ? result.data : false;
        },
    },
});

function Component() {
    const params = Route.useParams();

    return <FormContainerBoleto {...params} />;
}
